import _ from 'lodash';
import { createNotification } from 'react-redux-notify'
import { select, put, takeLatest, all } from 'redux-saga/effects'

import api from '../../Environment'
import {
  SEARCH_USER_START,
  FETCH_HOME_POSTS_START,
  FETCH_LISTS_DETAILS_START,
  FETCH_POST_SUGGESTION_START,
  FETCH_OTHERS_SINGLE_POST_START,
} from '../actions/ActionConstant'

import {
  searchUserFailure,
  searchUserSuccess,
  fetchHomePostsFailure,
  fetchHomePostsSuccess,
  fetchListsDetailsSuccess,
  fetchListsDetailsFailure,
  fetchOtherSinglePostFailure,
  fetchOtherSinglePostSuccess,
  fetchPostSuggesstionFailure,
  fetchPostSuggesstionSuccess,
} from '../actions/HomeAction'
import UserStorage from '../../helpers/storage/user'
import { getErrorNotificationMessage, getSuccessNotificationMessage } from '../../components/helper/NotificationMessage'
import { hideErrorComponent, showErrorComponent } from '../actions/ComponentAction'
import { fieldsToKeep } from '../../helpers/constants/storage'

function* fetchHomePostAPI(action) {
  try {
    const response = yield api.postMethod(action.data.url || 'all_posts', { skip: action.data.page || 0 })
    if (response.data.success) {
      yield put(hideErrorComponent());
      yield put(fetchHomePostsSuccess(response.data.data))
      if (response.data?.data?.user) {
        UserStorage.updateUser(_.pick(response.data.data.user, fieldsToKeep));
      }
    } else {
      yield put(fetchHomePostsFailure(response.data.error))
      const notificationMessage = getErrorNotificationMessage(response.data.error)
      yield put(createNotification(notificationMessage))
    }
  } catch (error) {
    yield put(fetchHomePostsFailure(error))
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

function* searchUserAPI() {
  try {
    const inputData = yield select((state) => state.search.filtersUser.inputData)
    const response = yield api.postMethod('users_search', inputData)
    if (response.data.success) {
      yield put(searchUserSuccess(response.data.data))
    } else {
      yield put(searchUserFailure(response.data.error))
      const notificationMessage = getErrorNotificationMessage(response.data.error)
      yield put(createNotification(notificationMessage))
    }
  } catch (error) {
    yield put(searchUserFailure(error))
    yield put(showErrorComponent({error:error, status:error.response.status ?  error.response.status : 500}))
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

function* fetchOtherSinglePostAPI() {
  try {
    const inputData = yield select((state) => state.post.singlePost.inputData)
    const response = yield api.postMethod('posts_view', inputData)
    if (response.data.success) {
      yield put(fetchOtherSinglePostSuccess(response.data.data))
      const notificationMessage = getSuccessNotificationMessage(response.data.message)
      yield put(createNotification(notificationMessage))
    } else {
      yield put(fetchOtherSinglePostFailure(response.data.error))
      const notificationMessage = getErrorNotificationMessage(response.data.error)
      yield put(createNotification(notificationMessage))
    }
  } catch (error) {
    yield put(fetchOtherSinglePostFailure(error))
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

function* fetchPostSuggesstionAPI() {
  try {
    const inputData = yield select((state) => state.post.delPost.inputData)
    const response = yield api.postMethod('user_suggestions', inputData)
    if (response.data.success) {
      yield put(fetchPostSuggesstionSuccess(response.data.data))
    } else {
      yield put(fetchPostSuggesstionFailure(response.data.error))
      const notificationMessage = getErrorNotificationMessage(response.data.error)
      yield put(createNotification(notificationMessage))
    }
  } catch (error) {
    yield put(fetchPostSuggesstionFailure(error))
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

function* fetchListsAPI() {
  try {
    const response = yield api.postMethod('lists_index')
    if (response.data.success) {
      yield put(fetchListsDetailsSuccess(response.data.data))
    } else {
      yield put(fetchListsDetailsFailure(response.data.error))
      const notificationMessage = getErrorNotificationMessage(response.data.error)
      yield put(createNotification(notificationMessage))
    }
  } catch (error) {
    yield put(fetchListsDetailsFailure(error))
    if(error?.response?.status !== 400){
      yield put(showErrorComponent({error:error, status:error?.response?.status ?  error?.response?.status : 500}));
    }
    const notificationMessage = getErrorNotificationMessage(error.message)
    yield put(createNotification(notificationMessage))
  }
}

export default function* pageSaga() {
  yield all([yield takeLatest(SEARCH_USER_START, searchUserAPI)])
  yield all([yield takeLatest(FETCH_HOME_POSTS_START, fetchHomePostAPI)])
  yield all([yield takeLatest(FETCH_LISTS_DETAILS_START, fetchListsAPI)])
  yield all([yield takeLatest(FETCH_OTHERS_SINGLE_POST_START, fetchOtherSinglePostAPI)])
  yield all([yield takeLatest(FETCH_POST_SUGGESTION_START, fetchPostSuggesstionAPI)])
}
